import React, {useState} from "react";
import UniversityList from "../components/UniversityList";
import UniversityModal from "../components/UniversityModal";
import {useNavigate} from "react-router-dom";
import AddCRMModal from "../components/AddCRMModal";
import Sidebar from "../components/Sidebar";

const UniversityManagement = () => {
    const [showModal, setShowModal] = useState(false);
    const [showCRMModal, setShowCRMModal] = useState(false);
    const [selectedUniversity, setSelectedUniversity] = useState(null);
    const navigate = useNavigate(); // For navigation
    const role = localStorage.getItem("role"); // Fetch user role
    const handleSave = () => {
        console.log("Closing modal...");
        setShowModal(false);
        setSelectedUniversity(null);
    };
    const handleCRMSave = () => {
        console.log("Closing modal...");
        setShowCRMModal(false);
        setSelectedUniversity(null);
    };
    const handleLogout = (event) => {
        event.preventDefault();
        console.log("Navigating to /login...");
        localStorage.clear(); // Clear all stored session data
        navigate("/login");
    };
    const handleEdit = (university) => {
        console.log("Editing university:", university);
        setSelectedUniversity(university);
        setShowModal(true);
    };

     const handleCRMEdit = (university) => {
        console.log("Editing university:", university);
        setSelectedUniversity(university);
        setShowCRMModal(true);
    };

    return (
        <div className="dashboard">
            <Sidebar/>
            <main className="main-content">
                <div>
                    <header className="header component">
                        <span className="component-header">Universities</span>
                        <button
                            className="btn btn-primary action"
                            onClick={() => {
                                setSelectedUniversity(null);
                                setShowModal(true);
                            }}
                        >
                             <i className="fa fa-plus"></i>  Add University
                        </button>
                    </header>
                    <hr/>
                    <UniversityList onEdit={handleEdit} onEditCRM={handleCRMEdit}/>
                    {showModal && (
                        <UniversityModal
                            university={selectedUniversity}
                            onClose={() => setShowModal(false)}
                            onSave={handleSave}
                        />
                    )}
                    {showCRMModal && (
                        <AddCRMModal
                            university={selectedUniversity}
                            onClose={()  => setShowCRMModal(false)}
                            onSave={handleCRMSave}
                        />
                    )}
                </div>
            </main>
        </div>
    );
};

export default UniversityManagement;